import { utils } from "pixi.js";

window.PIXI = PIXI;

// PixiApp imports.
import { UserAgent, AssetLoader, PixiApp } from "@cc/pixi-app";

// @cc/tp-exporter exported atlas manifest, describes all texture atlases.
import atlasManifest from "../../exports/atlases/atlas-manifest.json";
import texturesConfig from "../data/textures-config.json";

// Generated by @cc/audio-exporter. Used by @cc/soundjs-manager.
import audioManifest from "../../exports/audio/audio-manifest.json";

// App setup.
import NickSDKExpose from "script-loader!./exposesdk.min.js";
import NickSDK from "script-loader!./sdk-build.js";
import jsembed from 'script-loader!./jsembed.js';
import { PreloadScreen } from "./preloader";
import { LoadScreen } from "./loader";
import { screenConfig } from "./screens";
import { colors } from "./colors";
import { env } from "./env";
import { dataImporter } from "./DataImporter";
import { PerformanceManager } from "./common/PerformanceManager";
import { ifvisible } from "ifvisible.js";

/**
 * Screen resolutions (assuming natural height 1440).
 * There must be a scale variant with an equal value to the scale
 * used in tp-exporter config.
 */
const d1440 = 1,
    d1080 = 0.75,
    d720 = 0.5,
    d480 = 0.333,
    d360 = 0.25;

/**
 * PixiApp instance. Most scripts will have reference to this through
 * a screen instance, but it can also be imported from here. initApp
 * must be called before it is defined.import { dataImporter } from './DataImporter';
import { performanceManager } from './common/PerformanceManager';

 * @type {PixiApp | undefined}
 */
export let app;

/**
 * @param {*} config
 */
export const initApp = config => {
    // Initialize Nick SDK
    nick_sdk_client.SDK.initialize();
    // Setup Base URL
    let baseUrl = nick_sdk_client.JSEmbedProxy.getBase() || "";

    config = config || {};
    config.container = config.container || window.document.body;
    config.baseUrl = baseUrl || "";
    AssetLoader.baseUrl = baseUrl;
    // Set main game container.
    const container = config.container || window.document.body;

    // Get the app scale variant.
    let scale = getScaleVariant();

    // Create a new PixiApp instance.
    app = new PixiApp({
        // Base app options
        ...{
            width: 1920,
            height: 1440,
            maxWidth: 3360,
            forceCanvas: !!env.params.canvas,
            scaleFactor: scale.value,
            backgroundColor: colors.black.hex,
            fullscreenTargetElement: window.document.body,
            maxPixelRatio: 1
        },
        // Environment specific app options
        ...env.appOptionOverrides
    });

    // Add screen configuration objects.
    app.addScreens(screenConfig);
    // Set the loader display class, which is instanced and shown between screen changes.
    app.screenManager.setLoaderDisplayCtor(PreloadScreen);

    // Parse the @cc/tp-exporter configuration file.
    app.assets.parseTpConfig(texturesConfig, scale.key);
    // Parse the atlas data exported from @cc/tp-exporter.
    app.assets.parseManifest(atlasManifest);

    //Setup pack config
    dataImporter.setupConfig();

    // Load our loading screen assets in order to show first loading screen.
    app.assets.addAssetsWithTags(["loader", "config"]);
    // Once complete, kick things off.
    app.loader.once("complete", () => {
        container.appendChild(app.view);
        dataImporter.onConfigLoaded(() => {
            app.showScreen("splash");
        });
    });

    window.app = app;

    // Start load.
    app.loader.load();

    app.performanceManager = new PerformanceManager();

    // Setup the sound manager.
    audioManifest.baseUrl = AssetLoader.baseUrl;
    app.sound.parseSoundConfig(audioManifest);
    for (const key in app.sound.cache) {
        if (app.sound.cache.hasOwnProperty(key)) {
            const sound = app.sound.cache[key];
            app.assets.bank.push({
                sound: sound,
                name: "sound-" + sound.name,
                assets: [sound.src],
                isSoundAsset: true,
                tags: sound.config.tags,
                type: "sound"
            });
        }
    }

    nick_sdk_client.GameEventListener.onAudioToggle = bool => {
        app.sound.muted = !bool;
    };

    ifvisible.on("blur", () => {
        app.sound.blurred = true;
        console.log("blurred");
    });

    ifvisible.on("focus", () => {
        app.sound.blurred = false;
        console.log("focused");
    });
};

/**
 * Asset scale selection.
 */
const getScaleVariant = function () {
    let scale,
        minSide = Math.min(
            (window.screen && window.screen.width) || window.innerWidth,
            (window.screen && window.screen.height) || window.innerHeight
        );
    if (env.params.res) scale = parseFloat(env.params.res);
    else if (UserAgent.isiPad2 || UserAgent.isAmazon) scale = d480;
    else if (!utils.isMobile.any) {
        if (UserAgent.isIe) scale = d720;
        else if (minSide * window.devicePixelRatio > 720) scale = d1080;
        else scale = d720;
    } else {
        if (minSide * window.devicePixelRatio > 480) scale = d720;
        else scale = d480;
    }

    const scaleKey = `x${scale}`;
    return {
        key: scaleKey,
        value: scale
    };
};
